import React, { useRef } from "react";
import { Line, Circle } from "react-konva";

const MastColumnBeam = ({ lanterns, position, props, colorList, luminaires }) => {
  const lineRefs = useRef([]);

  return lanterns.map((lantern, idx) => {
    if (!lineRefs.current[idx]) lineRefs.current[idx] = React.createRef();
    const lineRef = lineRefs.current[idx];

    const angleRad = ((lantern.positionAngle - 90) * Math.PI) / 180;
    const beamLength = lantern.beamAimingInfo.beamLength ?? 0.75;

    const tipX = position.x + beamLength * Math.cos(angleRad);
    const tipY = position.y + beamLength * Math.sin(angleRad);

    const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
    const resolvedColor =
      luminaireIndex !== -1 && colorList[luminaireIndex]
        ? colorList[luminaireIndex]
        : "lightgray";

    return (
      <React.Fragment key={idx}>
        <Line
          ref={lineRef}
          points={[position.x, position.y, tipX, tipY]}
          stroke={resolvedColor === "#212529" ? "lightgray" : resolvedColor}
          strokeWidth={3 / props.stageScale}
        />
        <Circle
          x={tipX}
          y={tipY}
          radius={5 / props.stageScale}
          fill={resolvedColor === "#212529" ? "lightgray" : resolvedColor}
          draggable={props.selected}
          onDragMove={(e) => {
            const { x: dragX, y: dragY } = e.target.position();
            const dx = dragX - position.x;
            const dy = dragY - position.y;

            const angleDeg = (Math.atan2(dy, dx) * 180) / Math.PI;
            const newBeamLength = Math.sqrt(dx * dx + dy * dy);

            if (lineRef.current) {
              lineRef.current.points([position.x, position.y, dragX, dragY]);
              lineRef.current.getLayer().batchDraw();
            }

            props.updateLanternBeamEndpoint({
              beamEndPoint: { x: dragX, y: dragY },
              beamLength: newBeamLength,
              positionAngle: angleDeg + 90,
              lanternIndex: idx,
              columnIndex: props.i,
            });
          }}
          onDragEnd={(e) => {
            props.doAreaCalc()
          }}
        />
      </React.Fragment>
    );
  });
};

export default MastColumnBeam;
